export const ROLES = {
  SUPER_ADMIN: 380001,
  GAM: 380002,
  COUNTRY_ADMIN: 380003,
  SUPERVISOR: 380004,
  AGENT: 380005,
  WELLNESS_PROFESSIONAL: 380006, //added a static id, not a right role id valid from backend
};

export const ROLES_LABEL = {
  380001: "Super Administrator",
  380002: "Instance Administrator",
  380003: "Country Administrator",
  380004: "Supervisor",
  380005: "Agent",
  380006: "Wellness Professional",
};
